import { useSelector } from 'react-redux';

const PermisssionValidationWrapper = ({ pageName, children }) => {
    const { pagePermissions } = useSelector((state) => state.authentication);

    const doUserHaveEditPermision = () => {
        const foundItem = pagePermissions?.[pageName];
        if (foundItem?.hasEditPermission) {
            return true;
        } else return false;
    };

    return doUserHaveEditPermision() ? children : null;
};
export default PermisssionValidationWrapper;
